import {BaseTerms} from "../../infrastructure/models/base-terms";

export class FilterBarModuleTerms extends BaseTerms {}
